const checklistServiceButton = {
  create: 'CREATE SERVICE',
  scroll: 'GO TO UNANSWERED QUESTION',
  needAction: 'GO TO QUESTION WITHOUT ACTION',
  needSignatures: 'SIGNATURE IS MANDATORY',
};

export default checklistServiceButton;